import React from 'react';
import PropTypes from 'prop-types';

/**
 * WikiMenuItem — one row in the Knowledge dropdown: a menu-item button with a title and
 * description. The caller passes the already-computed aphrodite classes so the rendered
 * markup stays byte-identical to the original inline button.
 */
export default function WikiMenuItem({
  itemClassName,
  titleClassName,
  descClassName,
  title,
  description,
  onClick,
}) {
  return (
    <button type="button" className={itemClassName} onClick={onClick} role="menuitem">
      <span className={titleClassName}>{title}</span>
      <span className={descClassName}>{description}</span>
    </button>
  );
}
WikiMenuItem.propTypes = {
  itemClassName: PropTypes.string.isRequired,
  titleClassName: PropTypes.string.isRequired,
  descClassName: PropTypes.string.isRequired,
  title: PropTypes.node,
  description: PropTypes.node,
  onClick: PropTypes.func.isRequired,
};
WikiMenuItem.defaultProps = { title: null, description: null };
